import { Chart, type ChartType, Tooltip, type TooltipPositionerFunction } from 'chart.js';

declare module 'chart.js' {
  interface TooltipPositionerMap {
    cursorSide: TooltipPositionerFunction<ChartType>;
  }
}

// Required here: Chart.defaults.plugins.tooltip below would crash if this side-effect import runs before app.config.ts registers Tooltip.
Chart.register(Tooltip);

export type Bounds = { left: number; right: number; top: number; bottom: number };
export type CursorSidePosition = {
  x: number;
  y: number;
  xAlign: 'left' | 'right';
  yAlign: 'top';
};

const HORIZONTAL_GAP = 12;

export function cursorSidePosition(
  bounds: Bounds,
  cursor: { x: number; y: number },
  boxW: number,
  boxH: number,
): CursorSidePosition {
  let x = cursor.x + HORIZONTAL_GAP;
  let xAlign: 'left' | 'right' = 'left';
  if (x + boxW > bounds.right) {
    x = cursor.x - HORIZONTAL_GAP;
    xAlign = 'right';
  }
  let y = cursor.y;
  if (y + boxH > bounds.bottom) y = Math.max(bounds.top, bounds.bottom - boxH);
  if (y < bounds.top) y = bounds.top;
  return { x, y, xAlign, yAlign: 'top' };
}

Tooltip.positioners.cursorSide = function (_items, eventPos) {
  const chart = this.chart;
  const area = chart?.chartArea;
  if (!area || !eventPos || eventPos.x == null || eventPos.y == null) return false;
  const w = (this as { width?: number }).width ?? 0;
  const h = (this as { height?: number }).height ?? 0;
  return cursorSidePosition(area, { x: eventPos.x, y: eventPos.y }, w, h);
};

Chart.defaults.plugins.tooltip.position = 'cursorSide';
